/* eslint-disable jsx-a11y/control-has-associated-label */

import { commonIcons } from '@apps-common/config/icons'
import { ToastCloseTimerButton } from './ToastCloseTimerButton'

export declare type ToastType = 'info' | 'success' | 'warning' | 'error'

export interface IToastUIProps {
  message: string
  type?: ToastType
  icon?: any
  isPaused?: boolean
  toastProps?: any
}

export const ToastUI: React.FC<IToastUIProps> = ({ message, type, icon, isPaused, toastProps }) => {
  const defaultTimeout = toastProps?.autoClose || 5000

  let Icon = null

  if (!Icon) {
    if (type === 'success') {
      Icon = (
        <div className='bg-success text-on-success border border-on-success rounded-full w-[30px] h-[30px] min-w-[30px] min-h-[30px] flex items-center justify-center text-[1.4rem]'>
          <commonIcons.toastSuccess />
        </div>
      )
    } else if (type === 'warning') {
      Icon = (
        <div className='bg-warning text-on-warning border border-on-warning rounded-full w-[30px] h-[30px] min-w-[30px] min-h-[30px] flex items-center justify-center text-[1.1rem]'>
          <commonIcons.toastWarning />
        </div>
      )
    } else if (type === 'error') {
      Icon = (
        <div className='bg-error text-on-error border border-on-error rounded-full w-[30px] h-[30px] min-w-[30px] min-h-[30px] flex items-center justify-center text-[1.1rem]'>
          <commonIcons.toastError />
        </div>
      )
    } else {
      Icon = (
        <div className='bg-info text-on-info border border-on-info rounded-full w-[30px] h-[30px] min-w-[30px] min-h-[30px] flex items-center justify-center text-[1.1rem]'>
          <commonIcons.toastInfo />
        </div>
      )
    }
  }

  return (
    <div className=''>
      <div className='bg-surface text-text'>
        <div className='px-3 pt-3 pb-2 flex items-center justify-center gap-3'>
          {icon || Icon}
          <p className='grow jost text-[0.85rem] sm:text-[0.95rem]'>{message}</p>
          <ToastCloseTimerButton autoClose={defaultTimeout} paused={isPaused} onClose={() => toastProps?.closeToast()} />
        </div>
      </div>
    </div>
  )
}
